import { MNHNError } from '@/domain/MNHNError';

export class InvalidRestMission extends MNHNError {
  constructor(field: string) {
    super(`"${field}" can't be converted to Mission`);
  }
}
